// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPromoCodeApplyGiftcardResponse

export type WidgetPromoCodeApplyGiftcardApiResponse = {
	success: boolean;
	code: string | null;
	discountAmount: number | null;
	error: string | null;
};

export type WidgetPromoCodeApplyGiftcard = {
	success: boolean;
	code: string | null;
	discountAmount: number | null;
	error: string | null;
};

export function hydrateWidgetPromoCodeApplyGiftcard(data: WidgetPromoCodeApplyGiftcardApiResponse): WidgetPromoCodeApplyGiftcard {
	return { ...data };
}